// Fixed full-viewport aurora gradient layer (Aurora Glass signature).
// "full" is for marketing and auth; "quiet" is the dashboard/admin variant
// used by later redesign phases. Decorative only, hidden from AT.
export function AuroraBackground({
  variant = "full",
}: {
  variant?: "full" | "quiet";
}) {
  return (
    <div
      aria-hidden="true"
      className={variant === "quiet" ? "aurora-bg aurora-bg--quiet" : "aurora-bg"}
    />
  );
}
